import React from 'react';
import { Link } from 'react-router-dom';
import {
  ArrowRight,
  Rocket,
  Building2,
  Cpu,
  Briefcase,
} from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Card, CardHeader, CardTitle, CardDescription } from '../components/ui/card';

const PreIpoPartner = () => {
  const hiddenChampions = [
    {
      icon: <Building2 className="w-8 h-8" />,
      title: 'Zulieferer',
      description: 'Direkt vom Wachstum des Börsenkandidaten profitierend',
    },
    {
      icon: <Cpu className="w-8 h-8" />,
      title: 'Technologiepartner',
      description: 'Börsennotiert, oft systematisch unterbewertet',
    },
    {
      icon: <Briefcase className="w-8 h-8" />,
      title: 'Beteiligungsgesellschaften',
      description: 'Weit günstiger als der eigentliche IPO-Kandidat',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="flex flex-col">
              <div className="space-y-6">
              <div className="inline-flex items-center space-x-2 text-brand-700 font-medium">
                <Rocket className="w-5 h-5" />
                <span>Pre-IPO-Partner</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-brand-900 leading-tight">
                Die Pre-IPO-Partner-Strategie<sup className="text-2xl font-normal">®</sup>
              </h1>
              <p className="text-xl text-brand-700 leading-relaxed">
                Von uns entwickelt. Wenn Unternehmen an die Börse gehen, sind institutionelle
                Investoren längst positioniert.
              </p>
              <p className="text-2xl font-semibold text-brand-900 leading-relaxed">
                Wir gehen einen anderen Weg.
              </p>
              </div>
              <div className="mt-10">
              <Link to="/kontakt">
                <Button
                  size="lg"
                  className="bg-brand-900 hover:bg-brand-800 text-white px-8 py-3 text-base transition-all duration-300 hover:shadow-lg"
                >
                  Beratung anfragen
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </Link>
              </div>
            </div>
            <div className="relative h-[400px] lg:h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3"
                alt="Kapitalmarkt und Börsenanalyse"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-900/20 to-transparent" />
            </div>
          </div>
        </div>
      </section>

      {/* Hidden Champions Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-brand-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-brand-900 mb-6">
              Hidden Champions identifizieren
            </h2>
            <p className="text-xl text-brand-700 leading-relaxed max-w-4xl mx-auto">
              Wir identifizieren die Hidden Champions: Zulieferer, Technologiepartner und
              Beteiligungsgesellschaften, die vom Wachstum des Börsenkandidaten direkt profitieren
              — börsennotiert, oft systematisch unterbewertet, weit günstiger als der eigentliche
              IPO-Kandidat.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {hiddenChampions.map((item, index) => (
              <Card
                key={index}
                className="border-2 border-brand-200 hover:border-brand-400 transition-all duration-300 hover:shadow-lg"
              >
                <CardHeader className="p-8 text-center">
                  <div className="text-brand-700 mb-4 flex justify-center">{item.icon}</div>
                  <CardTitle className="text-2xl mb-3">{item.title}</CardTitle>
                  <CardDescription className="text-base text-brand-600 leading-relaxed">
                    {item.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Ergebnis Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="p-10 bg-brand-900 text-white rounded-2xl shadow-xl text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Das Ergebnis</h2>
            <p className="text-xl text-brand-100 leading-relaxed">
              Ein strukturell besserer Einstiegspunkt, breitere Substanz — ohne den überhitzten
              Ausgabepreis zu bezahlen.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-brand-50">
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center gap-8">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-900">
            Interesse an der Pre-IPO-Partner-Strategie?
          </h2>
          <p className="text-xl text-brand-700 max-w-3xl">
            Wir freuen uns auf Ihre Anfrage.
          </p>
          <Link to="/kontakt">
            <Button
              size="lg"
              className="bg-brand-900 hover:bg-brand-800 text-white px-10 py-3 text-lg transition-all duration-300 hover:shadow-lg"
            >
              Kontakt aufnehmen
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PreIpoPartner;
